// IDs das empresas (idEmpresa do token) que veem o botão IA do cabeçalho, agrupados por cliente.
const EMPRESAS_COM_IA_POR_CLIENTE = {
  icePolar: [2464, 2465, 2466, 2467, 2468, 2469, 2470, 2471, 2472, 2473, 2475, 3490, 3716],
  canecao: [629],
  poema: [3408],
  pipper: [3074, 3239, 3263, 3316, 688],
  coxinhasBady: [2356],
  estoril: [1350],
  outros: [202],
};

const IDS_EMPRESAS_COM_IA = new Set(Object.values(EMPRESAS_COM_IA_POR_CLIENTE).flat());

export function empresaTemIA(idEmpresa) {
  return IDS_EMPRESAS_COM_IA.has(Number(idEmpresa));
}
